export const getExtension = (filename: string): string => {
  const dotIndex = filename.lastIndexOf(".");
  const extension = filename.substring(dotIndex + 1);
  return extension;
};